export const UPDATE_PAGE_SIZE = 'UPDATE_PAGE_SIZE';

export const updatePageSize = (pageSize) => ({ type: UPDATE_PAGE_SIZE, pageSize });
